import { render } from "./ModalDataChangeRequest.vue?vue&type=template&id=4cf43c94&scoped=true"
import script from "./ModalDataChangeRequest.vue?vue&type=script&lang=js"
export * from "./ModalDataChangeRequest.vue?vue&type=script&lang=js"

import "./ModalDataChangeRequest.vue?vue&type=style&index=0&id=4cf43c94&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cf43c94"]])

export default __exports__